export const getTimeframeKey = ({ start, end }) => {
  if (start && end) {
    return `[${start.split('T')[0]}]-[${end.split('T')[0]}]`
  }
  return 'all-time'
}

export const getTimeframeFromKey = timeframeKey => {
  if (timeframeKey === 'all-time') return { start: null, end: null }
  const intervals = timeframeKey
    .split(']-[')
    .map(interval => interval
      .replace('[', '')
      .replace(']', '')
    )
  return {
    start: intervals[0],
    end: intervals[1]
  }
}
